/**
 * Changelog entries for F.R.A.N.C.A. AI.
 * Inspired by development logs; format: { date, description }.
 * Newest entries first.
 */
export const CHANGELOG_ENTRIES = [
  {
    date: '2026-03-25',
    description:
      'Image persistence fix: inline visuals now reliably survive page reload and chat switching. Upload retry on backend, metadata PATCH retry on frontend, race condition during typing animation resolved. Expired or deleted images show a clear placeholder with one-click regeneration instead of silently disappearing.',
  },
  {
    date: '2026-03-25',
    description:
      'Chat UX upgrade: article-style inline visual explanations inside assistant answers (up to 3 per response), adaptive sizing, fast-first model selection. Visuals persist across sessions and auto-expire after 3 days. Users can clear all generated media from settings.',
  },
  {
    date: '2026-03-11',
    description:
      'Projects soft-disabled (REACT_APP_PROJECTS_ENABLED=false): hidden from nav, lazy-loaded, project_id omitted from requests when disabled. Mirrors Arcano feature flag pattern.',
  },
  {
    date: '2026-03-11',
    description:
      'Cookie consent stored in a first-party cookie (SameSite=Lax, 1y expiry, Secure on HTTPS) instead of localStorage. Banner rendered via React portal for reliable visibility. Consent preferences accessible from Settings modal.',
  },
  {
    date: '2026-03-11',
    description:
      'Changelog modal added to chat footer. Version footer updated with clickable Changelog link and mailto link for feedback.',
  },
  {
    date: '2025-03-11',
    description:
      'Security package updates: axios, dompurify, react-router-dom (frontend); python-multipart, cryptography, langchain-core (backend). CVE fixes applied.',
  },
  {
    date: '2025-03-11',
    description:
      'CAD Designer: WebGL detection + fallback when unavailable (download GLB/STL). Router v7_startTransition. manifest.json/icons fix.',
  },
  {
    date: '2025-03-11',
    description:
      'CAD Designer: Stricter WebGL check, lazy-load model-viewer. Auth: Cache-Control no-cache on login redirect. package.json proxy for local dev.',
  },
  {
    date: '2025-03-11',
    description:
      'README updates: AI_FRANCA and frontend docs expanded with features, routes, API docs.',
  },
  {
    date: '2025-03-11',
    description:
      'Privacy-first update: Admin conversation view disabled by default (ENABLE_ADMIN_CONVERSATION_VIEW). Arcano soft-disabled (REACT_APP_ARCANA_ENABLED=false). GDPR cookie banner + preferences modal + footer link. FEATURE_FLAGS.md, PRIVACY_COOKIES.md.',
  },
]

export const CHANGELOG_ABOUT =
  'F.R.A.N.C.A. AI è l\'assistente AI avanzato per i dipendenti SFRE. Combina modelli AI, knowledge base, analisi documenti e integrazioni enterprise.'
